<ng-template #drawerContent>
  <div class="drawer-content">
    <div class="drawer-content_deco-line"></div>
    <div *ngIf="!hideHeader" class="drawer-content_header">
      <span class="p2">{{title}}</span>
      <app-button icon="close" (click)="closeDrawer()" [size]="'small'"></app-button>
    </div>
    <div class="drawer-content_panel">
      <ng-content></ng-content>
    </div>
  </div>
</ng-template>